var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("rect",{"className":"cls-1","x":"317.7","y":"530.56","width":"200.59","height":"570.31","rx":"17.63","key":0}),React.createElement("rect",{"className":"cls-1","x":"582.57","y":"530.56","width":"200.59","height":"570.31","rx":"17.63","key":1}),React.createElement("rect",{"className":"cls-1","width":"1100.86","height":"200.59","rx":"17.63","key":2}),React.createElement("rect",{"className":"cls-1","y":"264.86","width":"1100.86","height":"200.59","rx":"17.63","key":3})]))]);
}

LogoInline.defaultProps = {"viewBox":"0 0 1100.86 1100.86"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
